import { Select } from '@automata/ui';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Dispatch, SetStateAction } from 'react';

export type UnitOfMeasurementSelectProps = {
  value: string | null;
  units: string[];
  label?: string;
  onChange: Dispatch<SetStateAction<string>>;
};

const NO_UNIT_SELECTED = 'NO_UNIT_SELECTED';

export const UnitOfMeasurementSelect = ({
  value,
  units,
  label,
  onChange,
}: UnitOfMeasurementSelectProps) => {
  return (
    <FormControl sx={{ minWidth: 80 }}>
      <Select
        label={label}
        placeholder=""
        value={value ?? NO_UNIT_SELECTED}
        onChange={(e) => onChange(e.target.value as string)}
      >
        {units.map((unit: string) => (
          <MenuItem key={unit} value={unit}>
            <Stack direction="row" gap={1}>
              <Stack flex="2" justifyContent="center">
                <Typography variant="body2" lineHeight="unset">
                  {unit}
                </Typography>
              </Stack>
            </Stack>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
